import { inject, Injectable, InjectionToken, Type, ValueProvider } from '@angular/core';
import { DisplayType } from '@panaya/ai-chat/shared';

export interface CanvasDisplayRegistration {
    displayType: DisplayType;
    component: Type<unknown>;
}

export const CANVAS_DISPLAYS = new InjectionToken<CanvasDisplayRegistration[]>('__CANVAS_DISPLAYS__', {
    factory: (): CanvasDisplayRegistration[] => []
});

/**
 * Registers the component the frame renders for a `display_type`. It is standalone, takes
 * `@Input() params: Record<string, unknown>` and reads whatever store it needs. A later registration for the same
 * type replaces an earlier one.
 */
export function provideCanvasDisplay(displayType: DisplayType, component: Type<unknown>): ValueProvider {
    return { provide: CANVAS_DISPLAYS, useValue: { displayType, component }, multi: true };
}

@Injectable({ providedIn: 'root' })
export class CanvasDisplayRegistry {
    private readonly displays = new Map<DisplayType, Type<unknown>>(
        (inject(CANVAS_DISPLAYS, { optional: true }) ?? []).map(({ displayType, component }) => [displayType, component])
    );

    resolve(displayType: DisplayType): Type<unknown> | null {
        return this.displays.get(displayType) ?? null;
    }
}
